import React from "react";
import { Button, Col, Row, Modal, Spinner } from "react-bootstrap";
import { Button as ButtonMaterial } from "@mui/material";
import { Card, CardBody, CardHeader, Input, Label } from "reactstrap";
import { toast } from "react-toastify";
import { useState, useEffect } from "react";
import MUIDataTable from "mui-datatables";
import { MDBBadge } from "mdb-react-ui-kit";
import "react-loading-skeleton/dist/skeleton.css";
import RiskManagementGtPointMap from "./RiskManagementGtPointMap";
import RiskManagementGtPointDetailViewLatLongMap from "./RiskManagementGtPointDetailViewLatLongMap";
import {
  useGetGtPointSurveyQuery,
  useGetGtPointSurveyOldQuery,useGetGtPointHclDashboardQuery
} from "./RiskManagementApiSlice";
import Lightbox from "react-awesome-lightbox";
import "react-awesome-lightbox/build/style.css";
import { store } from "app/store";
import { API_URL } from "app/config";
import RiskManagementGtPointDetailViewPolygonMap from "./RiskManagementGtPointDetailViewPolygonMap";
import RiskManagementGtPointCreateBoundary from "./RiskManagementGtPointCreateBoundary";
import {useGtSaathiAprrovalbyIdMutation, useGtPointCreateBoundaryMutation,} from "./RiskManagementApiSlice";
import swal from "sweetalert";
import { useSelector } from "react-redux";
import { selectCurrentUser } from "features/auth/authSlice";
import { DateRangePicker } from "rsuite";
import "rsuite/dist/rsuite.css";
import moment from "moment";
import RiskManagementViewMap from "./RiskManagementViewMap";
import { selectLanguage } from "features/auth/authSlice";
// import { useTranslation } from "react-i18next";
import FileResponse from "./FileResponse";
import Tooltip from '@mui/material/Tooltip';
import NoEditingGtPoint from "./NoEditingGtPoint";
import CustomTable from "components/CustomTable";
const RiskManagementGtPoint = () => {
  const selectedLanguage = useSelector(selectLanguage);
  const currentUser = useSelector(selectCurrentUser);
  const [debouncedSearch, setDebouncedSearch] = useState("");

  const [searchKey, setSearchKey] = useState("");
  const [showLoaderTable, setLoaderTable] = useState(true);
  const [rowsPerPage, setRowsperPage] = useState(10);
  const [show, setShow] = useState(false);
  const [latlongData, setLatLongData] = useState([]);
  const [pagination, setPagination] = useState({
    offset: 0,
    limit: rowsPerPage,
    currentPage: 1,
  });
  const [dateKey, setDate] = useState("");
  let isHCL=currentUser?.realm_access?.roles?.includes("HCL")
  let state_name=isHCL?"UTTAR PRADESH":"";
  let district_name=isHCL?"Prayagraj":""
  let qc_approved=isHCL?"yes":""
  var GtPoint = useGetGtPointSurveyOldQuery({
    pagination,
    searchKey:debouncedSearch||"",
    dateKey,
    selectedLanguage,state_name,
    district_name,qc_approved
    }, { skip:isHCL } );
  
    var GtPointHcl = useGetGtPointHclDashboardQuery({  pagination,
      searchKey:debouncedSearch||"",
      dateKey,
      selectedLanguage,state_name,
      district_name,qc_approved }, { skip:!isHCL } );
  // const { data: getGtSurvey, refetch } = useGetGtPointSurveyOldQuery({
  //   pagination,
  //   searchKey,
  //   dateKey,
  //   selectedLanguage,state_name,
  //   district_name,qc_approved
  // }, {
  //   refetchOnMountOrArgChange: true,
  // });
  const { data: getGtSurvey,  refetch,isLoading,isFetching } =
  isHCL? GtPointHcl : GtPoint;
  
  const [updateList] = useGtPointCreateBoundaryMutation();
  const [GtPointSurvey, setGtPointSurvey] = useState([]);
  const [cropdata, setDetailList] = useState([]);
  const [cropdataLatLong, setDetailLatLong] = useState([]);
  const [cropdataFertilizer, setDetailFertilizerList] = useState([]);
  const [cropdataIrrigation, setDetailIrrigationList] = useState([]);
  const [openLightbox, setOpenLightBox] = useState(false);
  const [lightBoxViewImage, setImageInLightbox] = useState("");
  const [remarks, setRemarks] = useState("");
  const [updateQrProcess] = useGtSaathiAprrovalbyIdMutation();
  const [cardName, setCardValue] = useState("Details");
  const [editAllowed, setEditAllowed] = useState(false);
  const [editableFields, setEditableInputFields] = useState({
    CropName: "",
    CropVariety: "",
    PestiscideName: "",
    Remarks: "",
  });
  const [disableButton, setdisableSubmitBtn] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const RoleAcessParams = currentUser.groups;
  const [StartdateKey, setStartDate] = useState("");
  const [EndDateKey, setEndDate] = useState("");
  const [dateRange, setDateRange] = useState([]);
  const [StartdateKeyWithoutDocument, setStartDateWithoutDocument] = useState("");
  const [EndDateKeyWithoutDocument, setEndDateWithoutDocument] = useState("");
  const [dateRangeWithoutDocument, setDateRangeWithoutDocument] = useState([]);
  const [
    downloadLoadingWithoutDocument,
    setDownloadLoadingWithoutDocument,
  ] = useState(false);
  const [SortedArray, setSortedArray] = useState([]);
  const [FileModal, setFileModal] = useState(false);

  useEffect(() => {
    setPagination({ ...pagination, limit: rowsPerPage });
    setLoaderTable(false);
  }, [rowsPerPage]);
  useEffect(()=>{
    refetch()
  },[refetch])
  useEffect(() => {
    if (getGtSurvey !== undefined) {
      setGtPointSurvey(getGtSurvey?.data?.results);
      setLoaderTable(true);
    }
  }, [getGtSurvey]);
  useEffect(() => {
    const FilteredLatLong = [];
    GtPointSurvey?.map((item) => {
      if (Array.isArray(item.LatLong)) {
        FilteredLatLong.push(item.LatLong);
      }
    });
    setLatLongData(FilteredLatLong);
  }, [GtPointSurvey]);
  const handleShow = (list) => {
    setDetailList(list);
    setShow(true);
    if (Array.isArray(list?.Fertilizers)) {
      setDetailFertilizerList(list?.Fertilizers);
    }
    if (Array.isArray(list?.IrrigationInterval)) {
      setDetailIrrigationList(list?.IrrigationInterval);
    }
    if (Array.isArray(list?.LatLong)) {
      setDetailLatLong(list?.LatLong);
    }
    setEditableInputFields({
      CropName: list.cropName,
      CropVariety: list.cropVariety,
      PestiscideName: list.PestiscideName,
      Remarks: list.OtherRemark,
    });
    if (list.OtherMedia.length > 0) {
      const sortedData = [...list.OtherMedia]?.sort(function(a, b) {
        const attributeA = parseInt(a.Attribute.split("-")[1].trim());
        const attributeB = parseInt(b.Attribute.split("-")[1].trim());
        return attributeA - attributeB;
      });
      setSortedArray(sortedData);
    }
  };

  const state = {
    sortOrder: {},
    data: ["Loading Data..."],
    columns: [
      {
        name: "SurveyNo",
        label: "Survey No",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "CreatedName",
        label: "Created By",
        options: {
          filter: true,
          sort: true,
        },
      },

      {
        name: "CreatedMobile",
        label: "Phone No",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "CropName",
        label: "Crop Name",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "CropVariety",
        label: "Crop Variety",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "CreatedOn",
        label: "Created Date",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "VarietyName",
        label: "Variety Name",
        options: {
          filter: true,
          sort: true,
        
        },
      },
    
      {
        name: "view_details",
        label: "View Detail",
        options: {
          filter: true,
          sort: true,
          download: false,
        },
      },
    ],
    columns2: [
      {
        name: "SurveyNo",
        label: "Survey No",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "CreatedName",
        label: "Created By",
        options: {
          filter: true,
          sort: true,
        },
      },

      {
        name: "CreatedMobile",
        label: "Phone No",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "CropName",
        label: "Crop Name",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "CropVariety",
        label: "Crop Variety",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "CreatedOn",
        label: "Created Date",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "VarietyName",
        label: "Variety Name",
        options: {
          filter: true,
          sort: true,
        
        },
      },
      {
        name: "QCType",
        label: "Status",
        options: {
          filter: false,
          sort: true,
        },
      },
      {
        name: "view_details",
        label: "View Detail",
        options: {
          filter: true,
          sort: true,
          download: false,
        },
      },
    ],
    isLoading: false,
  };

  const getSrcData =
    GtPointSurvey &&
    GtPointSurvey?.map((list, index) =>
      list !== undefined
        ? {
            SurveyNo: list.SurveyNo,
            CreatedName: (
              <div className="text-center"> {list.CreatedName} </div>
            ),
            CreatedMobile: (
              <div className="text-center"> {list.CreatedMobile} </div>
            ),
            CropName: <div className="text-center"> {list.CropName} </div>,
            CropVariety: (
              <div className="text-center"> {list.CropVariety} </div>
            ),
            CreatedOn: (
              <div className="text-center">
                {list.CreatedOn ? list.CreatedOn.slice(0, 10) : ""}
              </div>
            ),
            VarietyName: (
              <div className="text-center"> {list.VarietyName} </div>
            ),
            QCType: (
              <MDBBadge
                pill
                color={
                  list.QCType === "Initiated" || list.QCType === "Pending"
                    ? "warning"
                    : list.QCType === "Allocated" ||
                      list.QCType === "Partially Completed"
                    ? "secondary"
                    : list.QCType === "Completed" ||
                      list.QCType === "QC1 Approved"
                    ? "success"
                    : list.QCType === "Error" || list.QCType === "QC1 Rejected"
                    ? "danger"
                    : "secondary"
                }
                className="p-2"
              >
                {" "}
                {list.QCType}
              </MDBBadge>
            ),
            view_details: (
              <>
                <div>
                  {" "}
                  <span
                    class="mdi mdi-eye text-warning mx-4 fs-5"
                    onClick={(e) => handleShow(list)}
                  ></span>
                </div>
              </>
            ),
          }
        : null
    );
  // const options = {
  //   page: pagination.currentPage - 1,
  //   rowsPerPage: rowsPerPage,
  //   search: false,
  //   download: false,
  //   count: getGtSurvey?.data?.count || 0,
  //   rowsPerPageOptions: [10, 50, 100, 500, 1000],
  //   serverSide: true,
  //   filterType: "dropdown",
  //   responsive: "standard",
  //   selectableRows: "none",
  //   filter: false,
  //   textLabels: {
  //     pagination: {
  //       next: "Next >",
  //       previous: "< Previous",
  //       rowsPerPage: "Total Per Page",
  //       displayRows: "OF",
  //     },
  //   },
  //   onChangePage(currentPage) {
  //     setLoaderTable(true);
  //     setPagination({
  //       offset: currentPage + 1 * rowsPerPage,
  //       limit: rowsPerPage,
  //       currentPage: currentPage + 1,
  //     });
  //   },
  //   onChangeRowsPerPage(numberOfRows) {
  //     setRowsperPage(numberOfRows);
  //   },

  // };

  const options = {
    page: pagination.currentPage - 1,
    rowsPerPage: rowsPerPage,
    search: false,
    download: false,
    count: getGtSurvey?.data?.count || 0,
    rowsPerPageOptions: [10, 50, 100, 500, 1000],
    serverSide: true,
    filterType: "dropdown",
    responsive: "standard",
    selectableRows: "none",
    filter: false,
    textLabels: {
      pagination: {
        next: "Next >",
        previous: "< Previous",
        rowsPerPage: "Total Per Page",
        displayRows: "OF",
      },
      body: {
        noMatch: isLoading || isFetching ? (
          <Spinner size={24} />
        ) : (
          "No data available"
        ),
      },
    },
    onChangePage(currentPage) {
      setLoaderTable(true);
      setPagination({
        offset: currentPage * rowsPerPage, // Corrected formula
        limit: rowsPerPage,
        currentPage: currentPage + 1,
      });
    },
    onChangeRowsPerPage(numberOfRows) {
      setRowsperPage(numberOfRows);
      setLoaderTable(true);
    },
  };
  

  const handleClose = (val) => {
    setShow(val);
    setCardValue("Details");
    setEditAllowed(false);
  };
  const handleLightBoxImage = (image) => {
    setImageInLightbox(image);
    setOpenLightBox(true);
  };
  const handleRemarks = (event) => {
    setRemarks(event.target.value);
  };

  const handleApproveReject = (val) => {
    if (remarks === "") {
      swal("Remarks is mandatory !!", {
        buttons: false,
        icon: "warning",
        title: "Please Enter Remark",
        timer: 1500,
      });
    } else {
      let action = "";
      if (val === "approve") {
        action = {
          action: "qc1_approved",
          qc_remark: remarks,
        };
      }
      if (val === "reject") {
        action = {
          action: "qc1_rejected",
          qc_remark: remarks,
        };
      }
      let id = cropdata.Id;
      updateQrProcess({ id, action })
        .then((response) => {
          if (response.data) {
            swal("Success", {
              buttons: false,
              icon: "success",
              title: response.data.message,
              timer: 1500,
            });
            setRemarks("");
            refetch();
            setShow(false);
          } else if (response.error) {
            swal("Error", {
              buttons: false,
              icon: "warning",
              title: response.error.data.message,
              timer: 3000,
            });
          }
        })
        .catch((error) => {
          console.log("catch", error);
        });
    }
  };

  const handleActiveCard = (cardName) => {
    setCardValue(cardName);
  };

  const handleEditAllow = () => {
    setEditAllowed(true);
    setdisableSubmitBtn(false);
  };
  const handleSaveAllow = (e) => {
    e.preventDefault();
    setEditAllowed(false);
    setdisableSubmitBtn(true);
    updateList({ id: cropdata.Id, payload: editableFields })
      .unwrap()
      .then((data) => {
        swal("Fields Updated", {
          buttons: false,
          icon: "success",
          title: "Successfully Updated ",
          timer: 1500,
        });
        handleClose(false);
        setdisableSubmitBtn(false);
        refetch();
      })
      .catch((error) => {
        toast.error("Error while Updating ");
        setdisableSubmitBtn(false);
        return;
      });
  };
  const handleInputChange = (e) => {
    setEditableInputFields({
      ...editableFields,
      [e.target.name]: e.target.value,
    });
  };
  const handleChangeSearch = (message) => {
    setSearchKey(message);
    setDate("");
  };
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchKey.trim() ? searchKey : "");
    }, 500); // 500ms debounce time
  
    return () => clearTimeout(handler);
  }, [searchKey]);
  const handleDateChange = (e) => {
    let date = new Date(e.target.value);
    let dateMDY = `${date.getDate()}/${date.getMonth() +
      1}/${date.getFullYear()}`;
    setSearchKey("");
    if (dateMDY === "NaN/NaN/NaN") {
      setDate("");
    } else setDate(dateMDY);
  };
  const handleStartEndDate = (value) => {
    setDateRange(value);
    if (value !== null && value.length > 0) {
      value.map((item, index) => {
        const inputDate = new Date(item);
        const formattedDate = moment(inputDate).format("YYYY-MM-DD"); // Adjust the format as needed
        if (index === 0) {
          setStartDate(formattedDate);
        }
        if (index === 1) {
          setEndDate(formattedDate);
        }
      });
    }
  };
  const disabledDate = (date) => {
    // Disable future dates
    return date && date > new Date();
  };
  const handleClean = () => {
    setDateRange([]);
    setStartDate("");
    setEndDate("");
  };

  const handleStartEndDateWithoutDocument = (value) => {
    setDateRangeWithoutDocument(value);
    if (value !== null && value.length > 0) {
      value.map((item, index) => {
        const inputDate = new Date(item);
        const formattedDate = moment(inputDate).format("YYYY-MM-DD"); // Adjust the format as needed
        if (index === 0) {
          setStartDateWithoutDocument(formattedDate);
        }
        if (index === 1) {
          setEndDateWithoutDocument(formattedDate);
        }
      });
    }
  };
  const disabledDateWithoutDocument = (date) => {
    return date && date > new Date();
  };
  const handleCleanWithoutDocument = () => {
    setDateRangeWithoutDocument([]);
    setStartDateWithoutDocument("");
    setEndDateWithoutDocument("");
  };
 

  return (
    <>
      <div className="page-content">
        <div className="text-gray mt-3 bg-white border p-3 pb-4">
          <Row>
          <div className="col-lg-3 mt-2">
        <label
        className="text-primary"
       style={{
        position: "relative",
      fontWeight: "600",
      marginLeft: "33px",
    }}
  >
    Download Without Documents
  </label>
  <div className="d-flex align-items-center mt-2" style={{ marginLeft: "33px" }}>
    <DateRangePicker
      value={dateRangeWithoutDocument}
      onChange={handleStartEndDateWithoutDocument}
      disabledDate={disabledDateWithoutDocument}
      onClean={handleCleanWithoutDocument}
      size="lg"
      style={{
        width: 240,
        marginRight: "10px",
      }}
    />
    {StartdateKeyWithoutDocument && EndDateKeyWithoutDocument ? (
      <Button
        id="AddLeads"
        className="bg-transparent text-primary fs-6"
        style={{
          padding: "10px",
          border: "1px solid orange",
          color: "#343737",
        }}
        size="sm"
       
        onClick={() => {
          const state = store.getState()
          fetch(
            `${API_URL}/survey/gt-point-survey/without-media-download/?start_date=${StartdateKeyWithoutDocument}&end_date=${EndDateKeyWithoutDocument}`,
            {
              headers: {
                authorization: `Bearer ${state.auth.accessToken}`,
              },
            }
          ).then((res) => {
            res.json().then((res) => {
              if (!res.data || Object.keys(res.data).length === 0) {
                swal(`${res.message}`, {
                  buttons: false,
                  icon: "warning",
                  title: "",
                  timer: 7500,
                  showCloseButton: true,
                  cancelButtonText: 'Close',
                });
                  setDownloadLoadingWithoutDocument(false)
                  return;
              
              }
                const fileURL = res.data?.link || "";
                  let alink = document.createElement('a');
                  alink.href = fileURL;
                  alink.download = 'farmers.csv';
                  alink.click();
                  setDownloadLoadingWithoutDocument(false)
                  setDateRangeWithoutDocument([]);
                  setStartDateWithoutDocument("");
                  setEndDateWithoutDocument("");
                
              })
          }).catch((err) => {
            setDownloadLoadingWithoutDocument(false);
            swal("No Data Found", {
              buttons: false,
              icon: "error",
              title: "Error",
              timer: 1500,
            });
          })
      }}

      >
        <span className="mdi mdi-download"></span>
        {downloadLoadingWithoutDocument ? (
          <Spinner
            animation="border"
            size="sm"
            className="text-warning"
          />
        ) : (
          ""
        )}
      </Button>
    ) : (
      ""
    )}
  </div>
  {/* <p className="text-grey" style={{ marginLeft: "33px" }}>
    Please select start and end date
  </p> */}
          </div>
            <div className="col-lg-3 mt-2">
  <label
    className="text-primary"
    style={{
      position: "relative",
      fontWeight: "600",
      marginLeft: "33px",
    }}
  >
    Download with Documents
  </label>
  <div className="d-flex align-items-center mt-2" style={{ marginLeft: "33px" }}>
    <DateRangePicker
      value={dateRange}
      onChange={handleStartEndDate}
      disabledDate={disabledDate}
      onClean={handleClean}
      size="lg"
      style={{
        width: 240,
        marginRight: "10px",
      }}
    />
    {StartdateKey && EndDateKey ? (
      <Button
        id="AddLeads"
        type=""
        className="bg-transparent text-primary fs-6"
        style={{
          padding: "10px",
          border: "1px solid orange",
          color: "#343737",
        }}
        size="sm"
      
        onClick={() => {
          const state = store.getState();
          setDownloadLoading(true);
          fetch(
            `${API_URL}/survey/gt-point-survey/download/?start_date=${StartdateKey}&end_date=${EndDateKey}`,
            {
              headers: {
                authorization: `Bearer ${state.auth.accessToken}`,
              },
            }
          )
            .then(async (response) => {
              const res = await response.json();

              if (!res.data || Object.keys(res.data).length === 0) {
                swal(`${res.message}`, {
                  buttons: false,
                  icon: "warning",
                  title: "",
                  timer: 7500,
                  showCloseButton: true,
                  cancelButtonText: 'Close',
                });
                setDownloadLoading(false);
                return; 
              }

              const fileURL = res.data?.link || "";
                let alink = document.createElement('a');
                alink.href = fileURL;
                alink.download = "application" + new Date().toDateString() + ".csv";
                alink.click();
                setDateRange([]);
                setStartDate("");
                setEndDate("");
                setDownloadLoading(false);
            })
            .catch((err) => {
              setDownloadLoading(false);
              swal("No Data Found", {
                buttons: false,
                icon: "error",
                title: "Error",
                timer: 1500,
              });
            });
        }}
      >
        <span className="mdi mdi-download"></span>{" "}
        {downloadLoading ? (
          <Spinner
            animation="border"
            size="sm"
            className="text-warning"
          />
        ) : (
          ""
        )}
      </Button>
    ) : (
      ""
    )}
  </div>
  {/* <p className="text-grey" style={{ marginLeft: "33px" }}>
    Please select start and end date
  </p> */}
           </div>
            <Col lg="6" className="mb-4 mt-4 ">
              <input
                type="text"
                placeholder="Search Name, Crop"
                className="inputBoxCss mx-2 mt-3"
                style={{
                  border: "1px solid #ced4da",
                  color: "grey",
                  height: "38px",
                }}
                value={searchKey}
                onChange={(e) => handleChangeSearch(e.target.value)}
              ></input>
              {dateKey ? (
                <input
                  type="date"
                  className="inputBoxCss mx-2 mt-3"
                  style={{
                    border: "1px solid #ced4da",
                    color: "grey",
                    height: "38px",
                  }}
                  defaultValue={dateKey}
                  onChange={(e) => handleDateChange(e)}
                ></input>
              ) : (
                <input
                  type="date"
                  className="inputBoxCss mx-2 mt-3"
                  style={{
                    border: "1px solid #ced4da",
                    color: "grey",
                    height: "38px",
                  }}
                  value=""
                  onChange={(e) => handleDateChange(e)}
                ></input>
              )}
         <Tooltip title="Downloads Files">
         <Button
        // className="btn btn-sm btn-primary"
        className="buttonOrangeDefaultColor"
        // style={{
        //   padding: "6px",
        //   border: "1px solid orange",
        //   color: "#343737",
        // }}
        onClick={() => setFileModal(true)}
       
      >
       Downloads
      </Button>
    </Tooltip>
            </Col>
          </Row>
        </div>
        <Col sm="12" className="mt-3">
          <Card className=" shadow-map p-1">
            <CardBody className="p-3 " style={{ backgroundColor: "#F5F5F5" }}>
              <RiskManagementGtPointMap
                GtPointSurvey={GtPointSurvey}
                latlongData={latlongData}
                refetch={refetch}
              />
            </CardBody>
          </Card>
        </Col>
      </div>
      <Row className="text-gray mt-3 bg-white border p-2 ">
        <Col className="col-12  ">
          <Card>
            <MUIDataTable
              className="shadow-none"
              data={getSrcData}
              loading={showLoaderTable}
              columns={isHCL?state.columns:state.columns2}
              options={options}
            />
            
          </Card>
        </Col>
        <Modal
          show={show}
          onHide={handleClose}
          dialogClassName="modal-90w"
          aria-labelledby="example-custom-modal-styling-title"
          size="xl"
          style={{ marginTop: "" }}
        >
          <Modal.Header closeButton style={{ marginTop: "" }}>
            <Modal.Title>Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
          {currentUser?.realm_access?.roles.includes("HCL")?
            <NoEditingGtPoint cardName={cardName} RoleAcessParams={currentUser?.realm_access?.roles} cropdata={cropdata} refetch={refetch} handleClose={()=>handleClose(false)} cropdataLatLong={cropdataLatLong} cropdataFertilizer={cropdataFertilizer} cropdataIrrigation={cropdataIrrigation}/>
            :<Row>
              <Col lg="1"></Col>
              <div className="">
                <div
                  className="radio-inputs text-center"
                  style={{ width: "45%", margin: "auto" }}
                >
                  <label className="radio">
                    <div onClick={() => handleActiveCard("Details")}>
                      <input type="radio" name="radio" defaultChecked />
                      <h5 className="name2  m-0">Details</h5>
                    </div>
                  </label>
                  <label className="radio">
                    <div onClick={() => handleActiveCard("Documents")}>
                      <input type="radio" name="radio" />
                      <h5 className="name2 text-primary m-0">Documents</h5>
                    </div>
                  </label>
                  <label className="radio">
                    <div onClick={() => handleActiveCard("Geo Tag")}>
                      <input type="radio" name="radio" />
                      <h5 className="name2 text-primary m-0">Geo Tag</h5>
                    </div>
                  </label>
                </div>
                {cardName === "Details" ? (
                  <>
                    <Card>
                      <CardBody>
                        <Row className="">
                          <Col lg="1" className="offset-md-11 ">
                            {editAllowed ? (
                              <ButtonMaterial
                                variant="contained"
                                color="success"
                                className="mx-3 mt-1"
                                onClick={handleSaveAllow}
                              >
                                SAVE
                                {disableButton ? (
                                  <Spinner animation="border" size="sm" />
                                ) : (
                                  ""
                                )}
                              </ButtonMaterial>
                            ) : (
                              <ButtonMaterial
                                variant="contained"
                                color="primary"
                                className="mx-3 mt-1"
                                onClick={handleEditAllow}
                              >
                                Edit
                              </ButtonMaterial>
                            )}
                          </Col>
                          <Col lg="3" className="mb-2">
                            <Label>Farmer Name</Label>
                            <Input
                              type="text"
                              name="FarmerName"
                              className="f400"
                              disabled
                              id=""
                              defaultValue={cropdata?.FarmerName}
                            />
                          </Col>{" "}
                          <Col lg="3" className="mb-2">
                            <Label>Farmer Phone No</Label>
                            <Input
                              type="text"
                              name="FarmerMobile"
                              className="f400"
                              disabled
                              id=""
                              defaultValue={cropdata?.FarmerMobile}
                            />
                          </Col>{" "}
                          <Col lg="3" className="mb-2">
                            <Label>Lat/Long</Label>
                            <Input
                              type="text"
                              name="CropName"
                              className="f400"
                              disabled
                              id=""
                              defaultValue={
                                cropdataLatLong.length > 0
                                  ? cropdataLatLong[0].lat.toFixed(4) +
                                    "/" +
                                    cropdataLatLong[0].long.toFixed(4)
                                  : ""
                              }
                            />
                          </Col>
                          <Col lg="3" className="mb-2">
                            <Label>Crop Name</Label>
                            <Input
                              type="text"
                              name="CropName"
                              className="f400"
                              disabled={editAllowed ? false : true}
                              id=""
                              defaultValue={cropdata?.CropName}
                              onChange={handleInputChange}
                            />
                          </Col>
                          <Col lg="3" className="mb-2">
                            <Label>Crop Variety</Label>
                            <Input
                              type="text"
                              name="CropVariety"
                              id=""
                              defaultValue={cropdata?.CropVariety}
                              className="f400"
                              disabled={editAllowed ? false : true}
                              onChange={handleInputChange}
                            />
                          </Col>
                          <Col lg="3" className="mb-3">
                            <Label>Crop Stage</Label>
                            <Input
                              type="text"
                              name="StressReason"
                              id=""
                              defaultValue={cropdata?.CropStage}
                              className="f400"
                              disabled
                            />
                          </Col>
                          <Col lg="3" className="mb-2">
                            <Label>Pesticide Name</Label>
                            <Input
                              type="text"
                              name="PestiscideName"
                              id=""
                              defaultValue={cropdata?.PestiscideName}
                              className="f400"
                              disabled={editAllowed ? false : true}
                              onChange={handleInputChange}
                            />
                          </Col>
                          <Col lg="3" className="mb-3">
                            <Label>Soil Moisture</Label>
                            <Input
                              type="text"
                              name="VarietyName"
                              id=""
                              defaultValue={cropdata?.SoilMoisture}
                              className="f400"
                              disabled
                            />
                          </Col>
                          <Col lg="3" className="mb-3">
                            <Label>Sowing Date</Label>
                            <Input
                              type="text"
                              name="IsIrrigated"
                              id=""
                              defaultValue={cropdata?.SowingDate}
                              className="f400"
                              disabled
                            />
                          </Col>
                          <Col lg="3" className="mb-3">
                            <Label>Remarks</Label>
                            <Input
                              type="text"
                              name="Remarks"
                              id=""
                              defaultValue={cropdata?.OtherRemark}
                              className="f400"
                              disabled={editAllowed ? false : true}
                              onChange={handleInputChange}
                            />
                          </Col>
                          <Col lg="3" className="mb-3">
                            <Label>Last Year Yield</Label>
                            <Input
                              type="text"
                              name="IrrigationCount"
                              id=""
                              defaultValue={cropdata?.LastYearYield}
                              className="f400"
                              disabled
                            />
                          </Col>
                          <Col lg="3" className="mb-3">
                            <Label>Is Disease Attack</Label>
                            <Input
                              type="text"
                              name="IsPestiscide"
                              id=""
                              defaultValue={
                                cropdata?.IsDiseaseAndPestAttack ? "Yes" : "No"
                              }
                              className="f400"
                              disabled
                            />
                          </Col>
                          <Col lg="3" className="mb-3">
                            <Label>Is Irrigated</Label>
                            <Input
                              type="text"
                              name="AnyStress"
                              id=""
                              defaultValue={
                                cropdata?.IsIrrigated ? "Yes" : "No"
                              }
                              className="f400"
                              disabled
                            />
                          </Col>
                          <Col lg="3" className="mb-3">
                            <Label>Irrigation Source</Label>
                            <Input
                              type="text"
                              name="StressReason"
                              id=""
                              defaultValue={cropdata?.IrrigationSource}
                              className="f400"
                              disabled
                            />
                          </Col>
                          <Col lg="3" className="mb-3">
                            <Label>Fertilizer Type</Label>
                            <Input
                              type="text"
                              name="StressReason"
                              id=""
                              defaultValue={cropdata?.FertilizerType}
                              className="f400"
                              disabled
                            />
                          </Col>
                        </Row>
                        {cropdataFertilizer.length > 0 ? (
                          <>
                            <h5 className="my-3 p-3 bg-secondary3">
                              Fertilizers{" "}
                            </h5>
                            <Row>
                              <Col lg="3" className="mb-3">
                                <Label>&nbsp;Name</Label>
                              </Col>
                              <Col lg="3" className="mb-3">
                                <Label>&nbsp;Quantity</Label>
                              </Col>
                            </Row>
                            {cropdataFertilizer?.map((item) => {
                              return (
                                <Row>
                                  <Col lg="3" className="mb-3">
                                    <Input
                                      type="text"
                                      name="StressReason"
                                      id=""
                                      defaultValue={item?.name}
                                      className="f400"
                                      disabled
                                    />
                                  </Col>
                                  <Col lg="3" className="mb-3">
                                    <Input
                                      type="text"
                                      name="StressReason"
                                      id=""
                                      defaultValue={item?.quantity}
                                      className="f400"
                                      disabled
                                    />
                                  </Col>
                                </Row>
                              );
                            })}
                          </>
                        ) : (
                          ""
                        )}

                        <h5 className="my-3 p-3 bg-secondary3">Irrigation </h5>

                        <Row>
                          <div>
                            &nbsp; Irrigation Count :{" "}
                            <span className="text-success f400">
                              {cropdata?.IrrigationCount}
                            </span>
                          </div>
                          {cropdataIrrigation?.length > 0 ? (
                            <>
                              <div className="mt-3 ">
                                {" "}
                                &nbsp;&nbsp;Irrigation Value :
                              </div>
                              <div className="d-flex mx-2">
                                {cropdataIrrigation?.map((item, index) => {
                                  return (
                                    <li className="mt-3 mx-4 f400  textlistHide">
                                      <span className=" f400 text-black">
                                        {index + 1}
                                        <span class="mdi mdi-chevron-right"></span>
                                      </span>{" "}
                                      <span className="text-success f400">
                                        {item?.name}
                                      </span>
                                    </li>
                                  );
                                })}
                              </div>
                            </>
                          ) : (
                            ""
                          )}
                        </Row>
                      </CardBody>
                    </Card>
                    <Row>
                      <Card className="mt-3">
                        <CardHeader className="mt-2">Boundary</CardHeader>
                        <CardBody>
                          {JSON.stringify(cropdata.FieldBoundaryMarking) !==
                            `{}` || cropdata.OtherMedia.length > 0 ? (
                            <RiskManagementViewMap
                              latLongData={cropdata.LatLong}
                              listData={cropdata}
                              otherMedia={cropdata.OtherMedia}
                            />
                          ) : JSON.stringify(cropdata.FarmBoundaryVerified) !==
                            `{}` ? (
                            <RiskManagementGtPointDetailViewPolygonMap
                              farmerBoundary={cropdata.FarmBoundaryVerified}
                              MediaData=""
                            />
                          ) : JSON.stringify(cropdata.FarmBoundaryVerified) ===
                              `{}` &&
                            JSON.stringify(cropdata.FarmBoundaryTagging) ===
                              `{}` ? (
                            <RiskManagementGtPointDetailViewLatLongMap
                              latLongData={cropdata.LatLong}
                            />
                          ) : (
                            <RiskManagementGtPointDetailViewPolygonMap
                              farmerBoundary={cropdata.FarmBoundaryTagging}
                              MediaData={cropdata.Media}
                            />
                          )}
                        </CardBody>
                      </Card>
                    </Row>
                    {RoleAcessParams.includes("developer") ||
                    RoleAcessParams.includes("admin") ||
                    RoleAcessParams.includes("State Head") ||
                    RoleAcessParams.includes("Checker") ? (
                      <Row>
                        <Card>
                          <CardBody className="p-2">
                            <Col className="col-lg-12 mb-2 ">
                              <h6 className="my-3 p-3 bg-secondary3">
                                {" "}
                                Take Action{" "}
                                <span className="float-end">
                                  {" "}
                                  Status :{" "}
                                  <span className="text-success f400">
                                    {cropdata?.QCType}
                                  </span>{" "}
                                </span>{" "}
                              </h6>
                              <form className="needs-validation">
                                <Col lg="12" className="mb-2">
                                  <Label>Remarks*</Label>
                                  <Input
                                    className=""
                                    type="textarea"
                                    id="textarea"
                                    name="remarks"
                                    placeholder="Please Enter Remark"
                                    value={remarks}
                                    onChange={handleRemarks}
                                    required
                                  />
                                </Col>
                                <Col className="text-center">
                                  <ButtonMaterial
                                    variant="contained"
                                    color="success"
                                    className="mx-3 mt-3"
                                    onClick={() =>
                                      handleApproveReject("approve")
                                    }
                                    disabled={
                                      cropdata?.QCType === "QC1 Approved" ||
                                      cropdata?.QCType === "QC1 Rejected"
                                        ? true
                                        : false
                                    }
                                  >
                                    Approve
                                  </ButtonMaterial>
                                  <ButtonMaterial
                                    variant="contained"
                                    color="error"
                                    className="mx-3 mt-3"
                                    onClick={() =>
                                      handleApproveReject("reject")
                                    }
                                    disabled={
                                      cropdata?.QCType === "QC1 Approved" ||
                                      cropdata?.QCType === "QC1 Rejected"
                                        ? true
                                        : false
                                    }
                                  >
                                    Reject
                                  </ButtonMaterial>
                                </Col>
                              </form>
                            </Col>
                          </CardBody>
                        </Card>
                      </Row>
                    ) : (
                      ""
                    )}
                  </>
                ) : cardName === "Documents" ? (
                  <Row>
                    {cropdata ? (
                      <Row>
                        {cropdata?.Media
                          ? cropdata?.Media?.map((list, index) =>
                              list.ImagePath !== "" ? (
                                <Col lg={3} key={list.index} className="mt-3">
                                  <Card className="text-center border ">
                                    <CardBody>
                                      <div className="img-fluid float-left">
                                        <p className="mb-1 text-uppercase">
                                          {list.Attribute}
                                        </p>
                                        <hr className="mt-2" />
                                        {list.ImagePath.includes("mp4") ? (
                                          <video
                                            width="320"
                                            height="240"
                                            controls
                                          >
                                            <source
                                              src={list.ImagePath}
                                              type="video/mp4"
                                            />
                                            <source
                                              src={list.ImagePath}
                                              type="video/ogg"
                                            />
                                          </video>
                                        ) : list.ImagePath.includes("pdf") ? (
                                          <object
                                            data={list.ImagePath}
                                            type="application/pdf"
                                            width="100%"
                                            height="400px"
                                          />
                                        ) : (
                                          <img
                                            src={list.ImagePath}
                                            onClick={() =>
                                              handleLightBoxImage(
                                                list.ImagePath
                                              )
                                            }
                                            alt=""
                                            className="img-fluid cursor-pointer"
                                          />
                                        )}
                                        <hr className="mt-2" />
                                        <p className="mb-1 text-uppercase">
                                          Accuracy :{" "}
                                          {list.Metadata
                                            ? list.Metadata.Accuracy
                                            : ""}
                                        </p>
                                        <p className="mb-1 text-uppercase">
                                          Azimuth :{" "}
                                          {list.Metadata
                                            ? list.Metadata.azimuth
                                            : ""}
                                        </p>
                                        <p className="mb-1 text-uppercase">
                                          Elevation :
                                          {list.Metadata
                                            ? list.Metadata.Elevation
                                            : ""}
                                        </p>
                                        {openLightbox ? (
                                          <Lightbox
                                            image={lightBoxViewImage}
                                            title="Image Title"
                                            onClose={() =>
                                              setOpenLightBox(false)
                                            }
                                          />
                                        ) : (
                                          ""
                                        )}
                                      </div>
                                    </CardBody>
                                  </Card>
                                </Col>
                              ) : null
                            )
                          : ""}
                        {SortedArray
                          ? SortedArray?.map((list, index) =>
                              list.FileName !== "" ? (
                                <Col lg={3} key={list.index} className="mt-3">
                                  <Card className="text-center border ">
                                    <CardBody>
                                      <div className="img-fluid float-left">
                                        <p className="mb-1 text-uppercase">
                                          {list.Attribute}
                                        </p>
                                        <hr className="mt-2" />
                                        {list.FileName.includes("mp4") ? (
                                          <video
                                            width="320"
                                            height="240"
                                            controls
                                          >
                                            <source
                                              src={list.FileName}
                                              type="video/mp4"
                                            />
                                            <source
                                              src={list.FileName}
                                              type="video/ogg"
                                            />
                                          </video>
                                        ) : list.FileName.includes("pdf") ? (
                                          <object
                                            data={list.FileName}
                                            type="application/pdf"
                                            width="100%"
                                            height="400px"
                                          />
                                        ) : (
                                          <img
                                            src={list.FileName}
                                            onClick={() =>
                                              handleLightBoxImage(list.FileName)
                                            }
                                            alt=""
                                            className="img-fluid cursor-pointer"
                                          />
                                        )}
                                        <hr className="mt-2" />
                                        <p className="mb-1 text-uppercase">
                                          Accuracy :{" "}
                                          {list.Metadata
                                            ? list.Metadata.Accuracy
                                            : ""}
                                        </p>
                                        <p className="mb-1 text-uppercase">
                                          Azimuth :{" "}
                                          {list.Metadata
                                            ? list.Metadata.azimuth
                                            : ""}
                                        </p>
                                        <p className="mb-1 text-uppercase">
                                          Elevation :
                                          {list.Metadata
                                            ? list.Metadata.Elevation
                                            : ""}
                                        </p>
                                        {openLightbox ? (
                                          <Lightbox
                                            image={lightBoxViewImage}
                                            title="Image Title"
                                            onClose={() =>
                                              setOpenLightBox(false)
                                            }
                                          />
                                        ) : (
                                          ""
                                        )}
                                      </div>
                                    </CardBody>
                                  </Card>
                                </Col>
                              ) : null
                            )
                          : ""}
                      </Row>
                    ) : null}
                  </Row>
                ) : (
                  <RiskManagementGtPointCreateBoundary
                    latLongData={cropdata.LatLong}
                    listData={cropdata}
                    refetch={refetch}
                    handleClose={handleClose}
                    otherMedia={cropdata.OtherMedia}
                  />
                )
                // <RiskGtMapOtherMedia latLongData={cropdata.LatLong} listData={cropdata} refetch={refetch} handleClose={handleClose} otherMedia={cropdata.OtherMedia} />
                }
              </div>
            </Row>
             }
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </Row>
      <Modal show={FileModal} size="xl" onHide={() => setFileModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Download File</Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-3">
             <FileResponse/>
          </Modal.Body>
          <Modal.Footer></Modal.Footer>
        </Modal>
    </>
  );
};

export default RiskManagementGtPoint;
